// lodash components
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'

const mutations = {
    setSearching(state, payload) {
        state.searching = payload
    },
    translateRtwSortOptions(state) {
        forEach(state.sortOptionLists, (list, i) => {
            forEach(list, (option, i) => {
                option.name = state.$t(option.name)
            })
        })
    },
    setActiveSortOptionList(state, payload) {
        if (!isEmpty(state)) {
            state.activeSortOptionList = payload
        } else {
            state.activeSortOptionList = 'default'
        }
    },
}

const actions = {}

const getters = {
    getRatesCurrentSortSelected(state, getters) {
        return find(getters.getRatesSortOptions, function (sortOption) {
            return sortOption.active
        })
    },
    getRatesSortOptions(state) {
        return state.sortOptionLists[state.activeSortOptionList]
    },
}

export { mutations, actions, getters }
